// LoadingSkeleton.tsx
import React from "react";

const LoadingSkeleton: React.FC = () => {
  return (
    <div style={{ padding: "1rem" }}>
      {[1, 2, 3, 4].map((item) => (
        <div
          key={item}
          style={{
            backgroundColor: "#f4f4f4",
            height: "80px",
            marginBottom: "8px",
            borderRadius: "4px",
          }}
        />
      ))}
    </div>
  );
};

export default LoadingSkeleton;
